import React, {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {getTrunksDictionary} from "../../../../redux/api/apiRoles";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {setUserField, setUserTrunkIds} from "../../../../redux/actions/actionsUsersList";
import {classNames} from "primereact/utils";
import {getUsersDirectoriesGetTrunksPhones} from "../../../../redux/api/apiUsersList";
import {InputSwitch} from "primereact/inputswitch";
import {Divider} from "primereact/divider";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {getTrunkById} from "../../../../redux/api/apiTrunks";
import {setTrunkDialogVisible} from "../../../../redux/actions/actionsTrunk";
import {setEditType} from "../../../../redux/actions/actions";
import TrunkListDialog from "../../TrunksList/TrunkDialog";
import {
    isTrunkIdInactive,
    keepCurrentTrunkSelectable,
    TrunkNameField,
    trunkInactiveLabel,
    trunkSelectItemTemplate,
    trunkSelectValueTemplate,
    uniqueTrunkOptions
} from "../../../../utils/trunkActivity";

const UserPhoneSettings = () => {
    const dispatch = useAppDispatch();
    // @ts-ignore
    const companiesDirectoryTranksPhones = useAppSelector(state => state.UsersListReducer.usersDirectoryTrunksPhone);
    // @ts-ignore
    const trunksDictionary = useAppSelector(state => state.UsersListReducer.userTrunksDictionary);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    // @ts-ignore
    const userData = useAppSelector(state => state.UsersListReducer.userData);
    // @ts-ignore
    const usersActiveTableToggle = useAppSelector(state => state.UsersListReducer.usersActiveTableToggle);
    // @ts-ignore
    const usersDialogUnzipping = useAppSelector(state => state.UsersListReducer.usersDialogUnzipping);
    // @ts-ignore
    const errorFields = useAppSelector(state => state.UsersListReducer.errorFields);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const [selectedPairs, setSelectedPairs] = useState([]);
    const emailField = useRef(null);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const rolePermissions = checkPermissions(rolesVision, 'Trunks');
    const [id, setId] = useState<boolean>(false);
    const trunkDialogVisible = useAppSelector(state => state.TrunksListReducer.trunkDialogVisible);
    const detailsLoading = useAppSelector(state => state.TrunksListReducer.detailsLoading) as unknown as Record<string, string[]>;
    // @ts-ignore
    const userDialogVisible = useAppSelector(state => state.UsersListReducer.dialogVisible);
    // @ts-ignore
    const userDetailsLoading = useAppSelector(state => state.UsersListReducer.detailLoading);
    const trunksIsBlock = !!userData?.user?.permission?.trunksIsBlock;

    const {
        visible: hasVisible,
        update: hasUpdatePermission
    } = rolePermissions;

    const trunksPhonesDict = Array.isArray(companiesDirectoryTranksPhones)
        ? companiesDirectoryTranksPhones
        : [];
    const userTrunkPhonesNo = Array.isArray(userData?.user?.trunkPhonesNo)
        ? userData.user.trunkPhonesNo
        : [];

    useEffect(() => {
        if (!userDialogVisible) {
            return;
        }
        if (userDetailsLoading) {
            return;
        }
        dispatch(getTrunksDictionary(jwtToken?.jwtToken));
        if (!trunksIsBlock) {
            dispatch(getUsersDirectoriesGetTrunksPhones(jwtToken?.jwtToken));
        }
    }, [userDialogVisible, userDetailsLoading, trunksIsBlock, jwtToken?.jwtToken]);

    const updateField = (order: any, updates: { trunkType?: any; trunkId?: any; trunkPhoneId?: any; trunkName?: any; }) => {
        setSelectedPairs((prev: any) => prev.map((item: { displayOrder: any; }) => item.displayOrder === order ? {...item, ...updates} : item));
    };

    const displayOrder = (rowData: { displayOrder: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal | null | undefined; }) => <div>{rowData?.displayOrder}</div>;

    const trunkType = (rowData: { trunkType: any; saved: any; displayOrder: any; }) => {
        const foundItem = trunksDictionary?.find((item: { dictionaryId: any; }) => item.dictionaryId === rowData?.trunkType);
        return (trunksIsBlock || rowData?.saved)
            ? <InputText className="opacity-100 w-full" disabled value={foundItem?.name || ''}/>
            : <Dropdown disabled={!usersDialogUnzipping && (!usersActiveTableToggle || !editType)} value={rowData?.trunkType} options={trunksDictionary} onChange={e => updateField(rowData?.displayOrder, {trunkType: e.value, trunkId: null, trunkPhoneId: null, trunkName: null})} optionLabel="name"
                        emptyMessage="нічого не знайдено" optionValue="dictionaryId" className="w-full"/>
    };

    const trunkName = (rowData: { displayOrder: any; trunkId: any; saved: any; trunkName?: any }) => {
        // const usedTrunkIdsWithoutPhone = selectedPairs
        //     .filter((pair: any) => pair.trunkPhoneId === null && pair.displayOrder !== rowData.displayOrder)
        //     .map((pair: any) => pair.trunkId);

        const hasGatewayError = errorFields?.userTrunks?.trunkIds?.includes(rowData?.trunkId);

        // const gateways = Array.from(
        //     new Map(
        //         companiesDirectoryTranksPhones
        //             .filter((item: { sofiaTrunkId: any }) =>
        //                 !usedTrunkIdsWithoutPhone.includes(item.sofiaTrunkId) ||
        //                 item.sofiaTrunkId === rowData.trunkId
        //             )
        //             .map((item: { sofiaTrunkId: any; profileName: any }) => [item.sofiaTrunkId, item.profileName])
        //     ).entries()
        // ).map(([value, label]) => ({value, label}));

        const gateways = keepCurrentTrunkSelectable(
            uniqueTrunkOptions(trunksPhonesDict, (item) => ({
                value: item.sofiaTrunkId,
                label: item.profileName,
            })),
            rowData.trunkId
        );

        const selectedLabel = rowData.trunkName
            || trunksPhonesDict.find(
                (item: any) => item.sofiaTrunkId === rowData.trunkId
            )?.profileName
            || rowData.trunkId
            || '';
        const trunkInactive = isTrunkIdInactive(trunksPhonesDict, rowData.trunkId);

        return (trunksIsBlock || rowData.saved || !trunksPhonesDict.length) ? (
            <TrunkNameField value={trunkInactiveLabel(selectedLabel)} inactive={trunkInactive} className="opacity-100"/>
        ) : (
            <Dropdown
                disabled={!usersDialogUnzipping && (!usersActiveTableToggle || !editType)}
                value={rowData.trunkId}
                options={gateways}
                filter
                optionValue="value"
                optionLabel="label"
                optionDisabled="disabled"
                itemTemplate={trunkSelectItemTemplate}
                valueTemplate={trunkSelectValueTemplate}
                emptyFilterMessage="Немає доступних"
                className={classNames('w-full trunk-select', {
                    'p-invalid': hasGatewayError || !rowData?.trunkId
                })}
                onChange={e => {
                    const selectedGateway = gateways.find((item: { value: any }) => item.value === e.value);
                    if (selectedGateway?.disabled) {
                        return;
                    }
                    updateField(rowData.displayOrder, {
                        trunkId: e.value,
                        trunkPhoneId: null,
                        trunkName: selectedGateway?.label || null
                    });
                }}
                emptyMessage="Немає доступних"
            />
        );
    };

    const trunkNumber = (rowData: { trunkPhoneId: any; trunkId: any; trunkType: number; saved: any; displayOrder: any; phoneNo?: any; }) => {
        const selectedPhoneIds = selectedPairs
            .map((pair: any) => pair.trunkPhoneId)
            .filter(id => id !== rowData.trunkPhoneId);

        const filteredCompanies = trunksPhonesDict
            .filter((company: { id: any; sofiaTrunkId: any; isReserved: any }) =>
                !selectedPhoneIds.includes(company.id) &&
                company.sofiaTrunkId === rowData.trunkId &&
                (rowData.trunkType !== 502 || !company.isReserved)
            )
            .sort((a: { phoneNo: string; }, b: { phoneNo: any; }) => a.phoneNo.localeCompare(b.phoneNo));

        const selectedPhone = rowData.trunkPhoneId != null
            ? trunksPhonesDict.find(
                (item: { id: any }) => item.id === rowData.trunkPhoneId
            )
            : undefined;

        const hasGatewayError = errorFields?.userTrunks?.trunkIds?.includes(rowData?.trunkId);
        const phoneValue = rowData.trunkPhoneId != null
            ? (selectedPhone?.phoneNo || rowData.phoneNo || '')
            : '';

        return (trunksIsBlock || rowData?.saved)
            ? <InputText className="opacity-100 w-full" disabled value={phoneValue}/>
            : <Dropdown
                disabled={!usersDialogUnzipping && (!rowData.trunkId || !usersActiveTableToggle || !editType)}
                value={rowData?.trunkPhoneId}
                options={filteredCompanies}
                optionValue="id"
                optionLabel="phoneNo"
                filter
                emptyFilterMessage="Немає доступних"
                onChange={e => updateField(rowData?.displayOrder, {trunkPhoneId: e.value})}
                className={classNames('w-full', {
                    'p-invalid': hasGatewayError
                })}
                emptyMessage="Немає доступних"
            />;
    };

    const deleteTrunk = (rowData: { displayOrder: any; }) => {
        if (trunksIsBlock) {
            return null;
        }
        return selectedPairs?.length > 1 ?
            <Button icon="pi pi-times" className="p-button-secondary" disabled={!usersDialogUnzipping && (!usersActiveTableToggle || !editType)} onClick={() => removePair(rowData.displayOrder)}/> : <></>;
    };

    useEffect(() => {
        if (!userData?.user?.userTrunks?.length) return;

        const mapped = userData.user.userTrunks
            .map((trunk: any, index: number) => {
                const foundPhone = trunk.trunkPhoneId != null
                    ? trunksPhonesDict.find((item: any) => item.id === trunk.trunkPhoneId)
                    : undefined;
                const foundTrunk = trunksPhonesDict.find((item: any) => item.sofiaTrunkId === trunk.trunkId);

                return {
                    trunkId: trunk.trunkId,
                    trunkPhoneId: trunk.trunkPhoneId,
                    trunkType: trunk.trunkType,
                    displayOrder: trunk.displayOrder || index + 1,
                    saved: true,
                    trunkName: trunk.trunkName || foundTrunk?.profileName,
                    phoneNo: trunk.trunkPhoneId != null
                        ? (foundPhone?.phoneNo || userTrunkPhonesNo[index] || trunk.phoneNo)
                        : ''
                };
            })
            .sort((a: any, b: any) => (a.displayOrder || 0) - (b.displayOrder || 0));

        setSelectedPairs(mapped);
    }, [userData?.user?.userTrunks, userData?.user?.trunkPhonesNo, companiesDirectoryTranksPhones]);

    useEffect(() => {
        if (!selectedPairs.length && userData?.user?.userTrunks?.length) return;
        if (trunksIsBlock) {
            return;
        }

        const cleanedPairs = selectedPairs.map((pair: any) => {
            const trunkName = pair.trunkName
                || trunksPhonesDict.find((item: any) => item.sofiaTrunkId === pair.trunkId)?.profileName
                || null;

            return {
                trunkId: pair.trunkId,
                trunkPhoneId: pair.trunkPhoneId,
                trunkType: pair.trunkType,
                displayOrder: pair.displayOrder,
                trunkName
            };
        });
        dispatch(setUserTrunkIds(cleanedPairs));
    }, [selectedPairs, userData?.user?.userTrunks, trunksIsBlock]);

    const addPair = (trunkId: null, trunkPhoneId: null, trunkType: number, order = null, saved = false) => {
        // @ts-ignore
        setSelectedPairs((prev: any) => {
            const newPair = {trunkId, trunkPhoneId, trunkType, displayOrder: prev.length + 1, saved};
            return [...prev, newPair].map((p, i) => ({...p, displayOrder: i + 1}));
        });
    };

    const removePair = (displayOrder: any) => {
        setSelectedPairs((prev: any) => prev.filter((p: { displayOrder: any; }) => p.displayOrder !== displayOrder).map((p: any, i: number) => ({...p, displayOrder: i + 1})));
    };

    const openEditor = (id: number) => {
        dispatch(getTrunkById(id, jwtToken?.jwtToken));
        dispatch(setTrunkDialogVisible(true));

        if (hasUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    };

    const showTrunkDetails = (rowData: any) => {
        if (trunksIsBlock || !hasVisible) return null;
        const isEditable = (usersActiveTableToggle && hasUpdatePermission) || usersDialogUnzipping;
        const icon = isEditable ? 'pi pi-pencil' : 'pi pi-eye';
        const isLoading = id === rowData.trunkId && Boolean(detailsLoading);
        const isDisabled = Boolean(id) && Boolean(detailsLoading);


        return <Button
            disabled={isDisabled}
            loading={isLoading}
            onClick={() => {
                openEditor(rowData?.trunkId);
                setId(rowData?.trunkId);
            }}
            icon={icon}
            style={{minHeight: '30px', minWidth: '30px', maxWidth: '37px'}}
            className={classNames(
                'p-button-secondary cursor-card-item flex align-items-center justify-content-center'
            )}
        />
    };

    return (
        <div>
            {trunkDialogVisible && <TrunkListDialog/>}
            <div className="field col-12 md:col-12 mb-0 pl-2">
                <label className="font-bold text-base mb-0">Revolver :</label>
                <div className="field-radiobutton mb-2 mt-4 pl-0">
                    <label className="mr-2 w-7rem">Не активний</label>
                    <InputSwitch
                        disabled={!usersDialogUnzipping && (!usersActiveTableToggle || (!editType))}
                        className="mr-3"
                        checked={userData?.user?.isRevolver}
                        onChange={e => dispatch(setUserField({section: 'user', fieldName: 'isRevolver', value: e.target.value}))}
                    />
                    <label>Активний</label>
                </div>
            </div>
            <Divider/>
            <label className="font-bold text-base mb-0">Контакти :</label>
            <DataTable emptyMessage={<></>} value={selectedPairs} reorderableColumns reorderableRows={!trunksIsBlock} onRowReorder={({dragIndex, dropIndex}) => {
                const updated: any = [...selectedPairs];
                const [moved] = updated.splice(dragIndex, 1);
                updated.splice(dropIndex, 0, moved);
                setSelectedPairs(updated.map((p: any, i: number) => ({...p, displayOrder: i + 1})));
            }} className="w-full">
                {!trunksIsBlock && <Column rowReorder style={{width: '3rem'}}/>}
                <Column body={displayOrder} style={{width: '3rem'}}/>
                <Column body={trunkType} style={{width: '15rem'}}/>
                {(!!trunksPhonesDict.length || trunksIsBlock || selectedPairs.some((pair: any) => pair?.trunkName) || userData?.user?.userTrunks?.some((trunk: any) => trunk?.trunkName)) && (
                    <Column body={trunkName} style={{width: '15rem'}}/>
                )}
                <Column body={trunkNumber} style={{width: '15rem'}}/>
                {!trunksIsBlock && <Column body={showTrunkDetails} style={{width: '40px'}}/>}
                {!trunksIsBlock && <Column body={deleteTrunk} style={{width: '15rem', paddingLeft: 0}}/>}
            </DataTable>
            <div className="grid col-12 md:col-6 pt-0">
                {errorFields?.userTrunks && <div className="col-12 md:col-12 p-0 m-0 pl-2 mb-1 mt-2"><span className="title p-error text-sm">{errorFields?.userTrunks?.userTrunks}*</span></div>}
            </div>
            {!trunksIsBlock && <Button className="mt-3" disabled={!usersDialogUnzipping && (!usersActiveTableToggle || (!editType))} icon="pi pi-plus" onClick={() => addPair(null, null, 501)}>
                <label className="pl-2">Додати транк</label>
            </Button>}
            <Divider/>
            <div className="field col-12 md:col-3 flex flex-column" ref={emailField}>
                <label htmlFor="address" className={classNames('', {'p-error': errorFields?.email})}>Email*</label>
                <InputText
                    id="address"
                    value={userData?.user?.email || ''}
                    className={classNames('', {'p-invalid': errorFields?.email})}
                    onChange={e => dispatch(setUserField({section: 'user', fieldName: 'email', value: e.target.value}))}
                    disabled={!usersDialogUnzipping && (!usersActiveTableToggle || (!editType))}
                />
                {errorFields && errorFields?.email &&  <label htmlFor="address" className={classNames('mt-2 mt-2 text-xs inline', {'p-error': errorFields?.email})}>{errorFields?.email?.email}</label>}
            </div>
        </div>
    );
};

export default UserPhoneSettings;
